// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";
// Data
import restockNotificationListData from "layouts/tables/data/releaseNotificationListData";
import MenuItem from "@mui/material/MenuItem";
import { useEffect, useMemo, useRef, useState } from "react";
import { Icon } from "@mui/material";
import MDInput from "../../components/MDInput";
import { API_URL } from "../../constants/constants";
import MDPagination from "../../components/MDPagination";
import MDButton from "../../components/MDButton";
import { DateRange } from "react-date-range";
import CustomPagination from "../../components/CustomPagination/CustomPagination";
import {
  autoHypenPhone,
  dateFormat,
  downloadCSV,
  getDataRangeInputs,
  showDataRange,
  toStringByFormatting
} from "../../Util";
import MDReleaseNotificationModifyModal from "../../components/MDReleaseNotificationModifyModal";
import MDModal from "../../components/MDModal";
import React from "react";
import { setSpinnerStatus, useMaterialUIController } from "../../context";


function MoodWaterReleaseNotification() {
  const [, dispatch] = useMaterialUIController();
  const [restockListData, setRestockListDataData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(5);
  const [size, setSize] = useState("20");
  const [userName, setUserName] = useState("");
  const [userId, setUserId] = useState("");
  const [targetWpId, setTargetWpId] = useState(null);
  const { columns, rows } = restockNotificationListData(restockListData, setTargetWpId);
  const [loading, setLoading] = useState(false);
  const [targetData, setTargetData] = useState([]);
  const [billingPhone, setBillingPhone] = useState("");
  const dataRangeRef = useRef(null);
  const [totalCount, setTotalCount] = useState(0);
  const [isShowDataRange, setIsShowDataRange] = useState(false);
  const [filterDateRange, setFilterDateRange] = useState([
    {
      startDate: null,
      endDate: null,
      key: "selection"
    }
  ]);

  const getRestockNotificationList = async () => {
    setSpinnerStatus(dispatch, true);
    await fetch(`${API_URL}/api/collins/moodwater/customers?name=${userName}&user_id=${userId}&billing_phone=${billingPhone}&page=${currentPage}${size === "all" ? "" : `&size=${size}`}${filterDateRange[0].startDate ? `&fromDate=${toStringByFormatting(new Date(filterDateRange[0].startDate))} 00:00:00` : ""}${filterDateRange[0].endDate ? `&toDate=${toStringByFormatting(new Date(filterDateRange[0].endDate))} 23:59:59` : ""}`, { credentials: "include" }).then((res) => res.json().then((r) => {
      if (r.data) {
        setRestockListDataData(r.data);
        const totalPage = Math.ceil(r.totalElements / r.size);
        setTotalPage(totalPage);
        setTotalCount(r.totalElements);
      } else {
        setTotalPage(0);
        setRestockListDataData([]);
        setTotalCount(0);

      }
      setSpinnerStatus(dispatch, false);
    }));
  };


  const filterDataRef = useRef(null);


  useEffect(() => {
    if (loading) {
      getRestockNotificationList();
    }
  }, [currentPage]);

  useEffect(() => {
    if (loading) {
      setCurrentPage(1);
      getRestockNotificationList();
    }
  }, [size]);

  useEffect(() => {
    getDataRangeInputs(filterDataRef, setFilterDateRange, setIsShowDataRange);
    document.body.addEventListener("click", (e) => {
      setIsShowDataRange(false);
      e.stopPropagation();
    });
  }, []);

  const releaseNotificationListDownload = async () => {
    await fetch(`${API_URL}/api/collins/moodwater/customers?${filterDateRange[0].startDate ? `&fromDate=${toStringByFormatting(new Date(filterDateRange[0].startDate))} 00:00:00` : ""}${filterDateRange[0].endDate ? `&toDate=${toStringByFormatting(new Date(filterDateRange[0].endDate))} 23:59:59` : ""}`, { credentials: "include" }).then((res) => res.json().then((r) => {
      const fileName = `출시알림신청현황_무드워터_${filterDateRange[0].startDate ? toStringByFormatting(new Date(filterDateRange[0].startDate)).replaceAll("-", "") + "-" : ""}${filterDateRange[0].endDate ? toStringByFormatting(new Date(filterDateRange[0].endDate)).replaceAll("-", "") : ""}`;
      if (r.data) {
        const columnName = ["ID", "WP ID", "성", "이름", "휴대전화 번호", "등록일", "알림 여부"];
        const csv = [];
        const rows = r.data;
        csv.push(columnName);
        rows.map((dataRow) => {
          const row = [];
          row.push(dataRow.id);
          row.push(dataRow.wp_user_id);
          row.push(dataRow.last_name.replaceAll(",", ""));
          row.push(dataRow.first_name.replaceAll(",", ""));
          row.push(dataRow.billing_phone);
          row.push(dataRow.registed_date);
          row.push(dataRow.use_yn ? "승인" : "거부");
          csv.push(row.join(","));
        });
        downloadCSV(csv.join("\n"), `${fileName}.csv`);
      }
    }));
  };

  useEffect(() => {
    showDataRange(isShowDataRange);
  }, [isShowDataRange]);


  const deleteNotification = async () => {
    await fetch(`${API_URL}/api/collins/moodwater/customer/${targetWpId}`, {
      method: "DELETE",
      credentials: "include"
    }).then(() => {
      document.getElementById("releaseNotificationDeleteModal").close();
      getRestockNotificationList();
    });
  };

  useEffect(() => {
    getRestockNotificationList().then(() => setLoading(true));
  }, []);


  return (
    <DashboardLayout>
      <MDReleaseNotificationModifyModal wpId={targetWpId} resetTargetWpId={() => setTargetWpId(null)}
                                        refresh={getRestockNotificationList} />
      <MDModal title={"삭제 하시겠습니까?"} action={() => deleteNotification()} id={"releaseNotificationDeleteModal"} />
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox mx={2} mt={-3} py={3} px={2} variant="gradient" bgColor="info" borderRadius="lg"
                     coloredShadow="info">
                <MDTypography variant="h6" color="white">
                  COLLINS
                </MDTypography>
                <MDTypography variant="h6" color="white">
                  출시 알림 현황 조회
                </MDTypography>
              </MDBox>
              <MDBox mx={1} mt={2} px={2} display="flex" flexWrap="wrap">
                <MDBox pr={1} mr={1} my={1} minWidth="150px">
                  <MDInput label="User ID" onChange={(e) => setUserId(e.target.value)} />
                </MDBox>
                <MDBox pr={1} mr={1} my={1} minWidth="150px">
                  <MDInput label="이름" onChange={(e) => setUserName(e.target.value)} />
                </MDBox>
                <MDBox pr={1} mr={1} my={1} minWidth="220px">
                  <MDInput fullWidth label="휴대전화 (예:010-1234-5678)"
                           value={billingPhone}
                           onChange={(e) => setBillingPhone(autoHypenPhone(e.target.value))} />
                </MDBox>
                <MDBox pr={1} mr={1} my={1}>
                  <MDButton color="success" onClick={() => getRestockNotificationList()}>검색하기</MDButton>
                </MDBox>
              </MDBox>
              <MDBox mx={1} px={1} variant="gradient" borderRadius="lg" display="flex"
                     style={{
                       alignItems: "center",
                       justifyContent: "space-between"
                     }}
              >
                <MDBox display="flex" style={{
                  flexDirection: "row",
                  flexWrap: "wrap",
                  alignItems: "center"
                }}>
                  <MDBox pr={1} mx={1}>
                    <DateRange
                      ref={dataRangeRef}
                      editableDateInputs={true}
                      onChange={(item) => {
                        filterDataRef.current = item.selection;
                        setFilterDateRange([item.selection]);
                      }}

                      moveRangeOnFirstSelection={false}
                      ranges={
                        filterDateRange
                      }
                      // locale={'korean'}
                    />
                  </MDBox>
                  {/*<MDBox pr={1} mx={1}>*/}
                  {/*  <MDButton color={"secondary"} onClick={() => setFilterDateRange([*/}
                  {/*    {*/}
                  {/*      startDate: null,*/}
                  {/*      endDate: null,*/}
                  {/*      key: "selection"*/}
                  {/*    }*/}
                  {/*  ])}>날짜 삭제</MDButton>*/}
                  {/*</MDBox>*/}
                  <MDBox pr={1} mx={1} display={"flex"} style={{ height: "40px" }}>
                    <MDButton color={"primary"} onClick={() => {
                      if (currentPage !== 1) {
                        setCurrentPage(1);
                      } else {
                        getRestockNotificationList();
                      }
                    }}>결과 조회</MDButton>
                  </MDBox>
                </MDBox>
                <MDBox style={{ justifyContent: "right", display: "flex", height: "40px" }}>
                  <MDButton color={"info"} onClick={() => releaseNotificationListDownload()}>CSV 다운로드</MDButton>
                </MDBox>
              </MDBox>
              <MDBox pt={3}>
                {/*<MDBox pr={3} pl={3} style={{ justifyContent: "right", width: "100%", display: "flex" }}>*/}
                {/*  <MDButton color={"info"} onClick={() => restockListDownload()}>CSV 다운로드</MDButton>*/}
                {/*</MDBox>*/}
                <MDBox pr={3} pl={3} my={2} style={{ justifyContent: "space-between", width: "100%", display: "flex" }}>
                  <MDBox width="200px">
                    <MDInput
                      size="medium"
                      select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={size}
                      label="페이지 당 표시 갯수"
                      onChange={(e) => setSize(e.target.value)}
                      InputProps={{
                        classes: { root: "select-input-styles" }
                      }}
                      fullWidth
                    >
                      <MenuItem value="10">10</MenuItem>
                      <MenuItem value="20">20</MenuItem>
                      <MenuItem value="30">30</MenuItem>
                      <MenuItem value="50">50</MenuItem>
                      <MenuItem value="100">100</MenuItem>
                    </MDInput>
                  </MDBox>
                  <MDBox style={{ display: "flex", alignItems: "center" }}>
                    <MDTypography style={{ fontSize: "13px" }} color="black">{totalCount}개의 알림 신청</MDTypography>
                  </MDBox>
                </MDBox>
                <DataTable table={{ columns, rows }} isSorted={false}
                           showTotalEntries={false} noEndBorder />
              </MDBox>

              <MDBox py={3} display="flex" justifyContent="center">
                <MDPagination>
                  <CustomPagination total={totalPage} itemsPerPage={4} currentPage={currentPage}
                                    setCurrentPage={(page) => setCurrentPage(page)} />
                </MDPagination>
              </MDBox>
            </Card>

          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default MoodWaterReleaseNotification;
